import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { FeatureFlagName, FeatureFlagService } from 'app/shared/services/feature-flag.service';

@Directive({
    selector: '[khRemoveIfFeatureOff]',
    standalone: false
})
export class RemoveIfFeatureOffDirective implements OnInit {
  @Input('khRemoveIfFeatureOff') public featureName!: FeatureFlagName;

  public constructor(
    private element: ElementRef,
    private readonly featureFlagService: FeatureFlagService){}

  public ngOnInit(): void {
    if (this.featureFlagService.isFeatureOff(this.featureName)) {
      this.element.nativeElement.parentNode.removeChild(this.element.nativeElement);
    }
  }
}
